import { render, staticRenderFns } from "./agreeDetail.vue?vue&type=template&id=2117e916&scoped=true"
import script from "./agreeDetail.vue?vue&type=script&lang=js"
export * from "./agreeDetail.vue?vue&type=script&lang=js"
import style0 from "./agreeDetail.vue?vue&type=style&index=0&id=2117e916&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2117e916",
  null
  
)

export default component.exports